import { notificationError } from '../../../../../components/Notifications/callNotifcation';
import { privateTemplateTagAPI } from '../../../../../entities/template/private-template-tag';
import { ITag } from '../../../../../entities/module/private-template-module-tag/api/types';
import { templateTagGroupApi } from '../../../../../entities/template/private-template-tag-group';
import { useAppDispatch } from '../../../../../shared/libs/redux';

/**
 * Хук для обновления тегов.
 */
export const useUpdateTags = () => {
	const [update, { isLoading }] = privateTemplateTagAPI.useUpdateMutation();
	const dispatch = useAppDispatch();

	const onUpdateTags = async (tags: ITag[]) => {
		try {
			const templateTags: ITag[] = tags.map((tag, index) => ({
				...tag,
				sequenceNumber: index,
			}));

			await update({ templateTags });

			dispatch(templateTagGroupApi.util?.invalidateTags(['templateTagGroup']));
			dispatch(privateTemplateTagAPI.util?.invalidateTags(['template_tags']));
		} catch (err) {
			console.error('Error updating private-template-private-template-module-tag:', err);
			notificationError('Произошла ошибка при изменении порядка категорий...');
			throw err;
		}
	};

	return {
		onUpdateTags,
		isLoading,
	};
};
